// extracted by mini-css-extract-plugin
export default {"modalHeader":"UpsellModal_modalHeader__Hcs4s","modalTitle":"UpsellModal_modalTitle__XLitm","modalBody":"UpsellModal_modalBody__QyzOc","button":"UpsellModal_button__BU1qe"};